import {
    DangerButton,
    PrimaryButton,
    PrimaryButtonHtml,
    SecondaryButton,
    SecondaryButtonHtml,
} from "../../components/Buttons/components/ActionButton";

export const ButtonDocs = () => {
    return (
        <table>
            <tr>
                <td>Ant</td>
                <td>HTML</td>
            </tr>
            <tr>
                <td>
                    <PrimaryButton>Primary</PrimaryButton>
                    <SecondaryButton>Secondary</SecondaryButton>
                    <DangerButton>Danger</DangerButton>
                    <PrimaryButton disabled>Primary Disabled</PrimaryButton>
                    <SecondaryButton disabled>Secondary Disabled</SecondaryButton>
                </td>
                <td>
                    <PrimaryButtonHtml>Primary</PrimaryButtonHtml>
                    <SecondaryButtonHtml>Secondary</SecondaryButtonHtml>
                </td>
            </tr>
        </table>
    );
};
